import { combineReducers } from "redux";
import CategoryReducers from "./CategoryReducers";
import ProductReducers from "./ProductReducers";
import ProgressReducers from "./ProgressReducer";
import CartReducers from "./CartReducers";
import AddressReducers from "./AddressReducers";
import PaymentReducers from "./PaymentReducers";
import PromotionReducers from "./PromotionReducers";
import CategoryParentReducers from "./CategoryParentReducers";

const RootReducers = combineReducers({
  products: ProductReducers,
  progress: ProgressReducers,
  categories: CategoryReducers,
  categoriesParent: CategoryParentReducers,
  carts: CartReducers,
  address: AddressReducers,
  payments: PaymentReducers,
  promotions: PromotionReducers,
});

export default RootReducers;
